import React from 'react';
import {
  DateField, ReferenceArrayInput, AutocompleteArrayInput, NumberInput, Filter, List, Datagrid, TextField, TextInput,
  NumberField, FunctionField } from 'react-admin';

const LineItemFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
    <ReferenceArrayInput source="order_id" label="Order" 
      reference="orders"
      basePath='orders'
      alwaysOn
      perPage={10}
      sort={{ field: 'name', order: 'ASC' }}
      filterToQuery={searchText => ({ search_name: searchText })}
      allowEmpty>
      <AutocompleteArrayInput label="Orders" optionText="name" optionValue="code" style={{ width: '90%' }} />
    </ReferenceArrayInput>
    <NumberInput label="LineItem ID" source="search_id" resettable />
  </Filter>
);

export const LineItemList = ({ permissions, ...props }) => (
  <List {...props} title="LineItems"
    filters={<LineItemFilter permissions={ permissions } />}
    perPage={25}
    bulkActionButtons={false}
    exporter={false}>

    <Datagrid rowClick="edit" size='medium'>
      {permissions && permissions.role === 'admin' && 
        <TextField source="code" label="ID" />
      }
      <TextField source="name" label="Name" />
      <DateField source="start_date_time" label="Start Date" />
      <DateField source="end_date_time" label="End Date" />
      <TextField source="status" label="Status" />
      <NumberField source="primaryGoal.units" label="Goal (Impressions)" />
      <NumberField source="stats.impressionsDelivered" label="Impressions Delivered" />
      <FunctionField label="Progress %" textAlign='right' render={
        record => {
          if (record.deliveryIndicator && record.deliveryIndicator.actualDeliveryPercentage) {
             return record.deliveryIndicator.actualDeliveryPercentage.toFixed(2);
          }
        }
      } />
      <FunctionField label="Forcasted Progress %" textAlign='right' render={
        record => {
          if (record.deliveryIndicator && record.deliveryIndicator.expectedDeliveryPercentage) {
             return record.deliveryIndicator.expectedDeliveryPercentage.toFixed(2);
          }
        }
      } />
      <NumberField source="stats.clicksDelivered" label="Clicks Delivered" />
    </Datagrid>
  </List>
);
